import { ExercisePlanTable } from "@/components/exercise-plans/exercise-plan-table"
import { PageHeader } from "@/components/shared/page-header"

export default function ExercisePlansPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Exercise Plans"
        description="Create and manage exercise plans for your clients"
      />
      <ExercisePlanTable />
    </div>
  )
}
